import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { branch, renderNothing } from 'recompose'

import TooltipButtonComponent from 'components/custom/ValidationTooltip/index'

const SliderValidationTooltip = branch(
  ({ isRisk }) => !isRisk,
  renderNothing
)(TooltipButtonComponent)

SliderValidationTooltip.propTypes = {
  isRisk: PropTypes.bool.isRequired,
}

SliderValidationTooltip.defaultProps = {
  isRisk: false,
}

export default SliderValidationTooltip
